// main.js
import { createApp } from 'vue'
import App from './App.vue'
import DemandWidgetPage from "@/widgets/DemandWidgetPage.vue";
import { resolveWidgetMode } from "@/widgets/resolveWidgetMode";

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { createPinia } from 'pinia'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


const vuetify = createVuetify({
    components,
    directives,
})

const widgetMode = resolveWidgetMode(window.location.pathname);
const RootComponent = widgetMode ? DemandWidgetPage : App;
const rootProps = widgetMode ? { mode: widgetMode } : {};

createApp(RootComponent, rootProps)
    .use(vuetify)
    .use(createPinia())
    .mount('#app')
